import React, { useState, useEffect } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import * as actions from "./_redux/Actions";
import { useSubheader } from "../../../_metronic/layout";
import {
    Card,
    CardBody,
    CardHeader,
    ModalProgressBar
} from "../../../_metronic/_partials/controls";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input } from "../../../_metronic/_partials/controls";
import DropdownReactSelect from "../../components/DropdownReactSelect";

import Upload from "../../components/upload/Upload";

const Setting = (props) => {
    const suhbeader = useSubheader();
    const dispatch = useDispatch();
    const [title, setTitle] = useState("");
    const [file, setFile] = useState(undefined);
    const [id, setId] = useState(undefined);
    // const { id } = useParams();
    // const id = undefined;
    const sid = '60d57866cb696f13f0fdd781';
    
    let history = useHistory();
    const [frmInitialValues, setFrmInitialValues] = useState(
        {
            title: '',
            helpText: '',
            featuredImage: '',
            isActive: true,
            company: "GJ"
        }
    );

    const [
        contestForDropdownFilterData,
        setContestForDropdownFilterData,
    ] = useState([]);

    const [
        contestForSelectedDropdownFilterData,
        setContestForListDropdownFilterData,
    ] = useState([]);

    // Validation schem
    const LevelsEditSchema = Yup.object().shape({
        title: Yup.string()
            .required("Title is required"),
        helpText: Yup.string()
            .required("helpText is required"),
    });

    const { currentState } = useSelector(
        (state) => ({ currentState: state.H5Games }),
        shallowEqual
    );
   
    const { actionsLoading, H5GamesSetting, companyDropdownList } = currentState

    useEffect(() => {
        if(contestForSelectedDropdownFilterData?.label){
            dispatch(actions.fetchSetting({ id: sid, companyCode: contestForSelectedDropdownFilterData?.code}));
        }
    }, [contestForSelectedDropdownFilterData, sid, dispatch]);

    useEffect(() => {
        let _title = "Html5 Game Setting";
        if (H5GamesSetting && sid) {
            const item = H5GamesSetting.item
            const data = { ...frmInitialValues, ...item };
            setFile(item && item.featuredImage);
            setFrmInitialValues(data);
            setId(item && item._id);
        }
        setTitle(_title);
        suhbeader.setTitle(_title);
    }, [H5GamesSetting, id]);

    const onUpdateFileValue = (file, name) => {
        if (name === 'featuredImage') {
            setFile(file.image)
        }
        setFile(file.image)
    }
    const saveForm = (values) => {
        values.featuredImage = file;
      
        if (id) {
          // Update existing setting
          const params = { ...values };
            params._id = id;
            params.company = contestForSelectedDropdownFilterData?.code
          dispatch(actions.updateSetting(params)).then((success) => {
            if (success) {
            //   NotificationManager.success("Setting updated successfully!"); // Display success toast
              setTimeout(() => backToList(), 2000); // Redirect after 2 seconds
            }
          });
        } else {
            // Create new setting
            const params = { ...values };
            params.company = contestForSelectedDropdownFilterData?.code
          dispatch(actions.createSetting(params)).then((success) => {
            if (success) {
            //   NotificationManager.success("Setting created successfully!"); // Display success toast
              setTimeout(() => backToList(), 2000); // Redirect after 2 seconds
            }
          });
        }
      };

    const backToList = () => {
        window.location.reload();
        // history.push(`/H5Games/list`);
    };

    useEffect(() => {
        dispatch(actions.fetchCompanyDropdownList());
    }, []);
    
    useEffect(() => {
        if (companyDropdownList && companyDropdownList?.data) {
          // let temp = [{
          //   _id: 0,
          //   label: "All",
          //   value: "all",
          //   baseUrl: "all",
          // }];
          let temp = [];
          const userdata = JSON.parse(localStorage.getItem("userData"));
          const userCompany = userdata?.company || [];
          companyDropdownList.data.forEach((element, i) => {
            // console.log(userCompany.includes(element._id));
            // console.log(!helperFunc.isAdmin());
            // if (!helperFunc.isAdmin()) {
            if (userCompany.includes(element._id)) {
              temp.push({
                _id: i + 1,
                label: element.name,
                value: element._id,
                baseUrl: element.baseUrl,
                code: element.code,
                "data-tokens": element.name,
              });
            }
            // } else {
            //   temp.push({
            //     _id: i + 1,
            //     label: element.name,
            //     value: element._id,
            //     baseUrl: element.baseUrl,
            //     code: element.code,
            //     "data-tokens": element.name,
            //   });
            // }
          });
          setContestForDropdownFilterData(temp);
        }
    }, [companyDropdownList]);

    return (
        <Card>
            {actionsLoading && <ModalProgressBar />}
            <CardHeader title={title}></CardHeader>
            <CardBody>
                <Formik
                    enableReinitialize={true}
                    initialValues={frmInitialValues}
                    validationSchema={LevelsEditSchema}
                    onSubmit={(values) => {
                        saveForm(values);
                    }}
                >
                    {({ handleSubmit, values }) => (
                        <Form className="form form-label-right">
                            <div className="form-group row">
                                <div
                                    className="col-lg-4 col-md-6 mt-2 "
                                    // style={{ maxWidth: "325px" }}
                                >
                                    <label>Select Company</label>
                                    <DropdownReactSelect
                                        placeholder={"Company"}
                                        name={"Company"}
                                        value={contestForSelectedDropdownFilterData}
                                        // isMulti={values.isShared == 'true' ? true : false}
                                        isMulti={false}
                                        isClearable={true}
                                        isSearchable={true}
                                        closeMenuOnSelect={true}
                                        options={contestForDropdownFilterData}
                                        onChange={setContestForListDropdownFilterData}
                                    />
                                </div>
                                <div className="col-lg-4 col-md-6 mt-2">
                                    <Field
                                        name="title"
                                        component={Input}
                                        placeholder="Title"
                                        label="Title"
                                    />
                                </div>
                                <div className="col-lg-4 col-md-6 mt-2">
                                    <Field
                                        name="helpText"
                                        component={Input}
                                        placeholder="Help Text"
                                        label="Help Text"
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label className="col-form-label">Is Active</label>
                                    <div className="col-12 w-100 p-0">
                                        <span className="switch switch-primary switch-icon">
                                            <label>
                                                <Field type="checkbox" name="isActive" />
                                                <span></span>
                                            </label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-lg-4">
                                    <Field
                                        name="featuredImage"
                                        component={Upload}
                                        label="Featured Image"
                                        file={file}
                                        onfileValueSet={onUpdateFileValue}
                                    />
                                </div>
                            </div>
                            <div className="form-group justify-content-end row mx-0">
                                <button
                                    type="button"
                                    onClick={backToList}
                                    className="btn btn-light"
                                >
                                    <i className="fa fa-arrow-left"></i>Back
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary ml-2"
                                > {id ? "Update" : "Save"}</button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </CardBody>
        </Card>
    )
}
export default Setting;